export default __webpack_public_path__ + "static/media/ic_video_chat_list.4a134b3d.svg";